import { useEffect, useState } from "react";
// import "./NewVendor.css";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  OverlayTrigger,
  Table,
  Tooltip,
  InputGroup,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import DynamicPagination from "../../components/DynamicPagination ";
import {
  IconPlus,
  IconUserCheck,
  IconUserOff,
  IconTrash,
  IconBug,
  IconHourglass,
  IconCircleCheck,
  IconCircleX,
  IconSearch,
  IconChecks,
  IconEdit,
  IconMessage2,
  IconEye,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import { toast } from "react-toastify";
import { hasPermission } from "../../utils/_helpers";
import "./bugs.css";
import UpdateStatus from "./UpdateStatus";
import AddComments from "./AddComments";
import ViewBugDetails from "./ViewBugDetails";
import useIdleLogout from "../../hooks/useIdleLogout";

const steps = [
  { id: 1, icon: <IconBug size={24} />, label: "Open" },
  { id: 2, icon: <IconHourglass size={24} />, label: "InProgress" },
  { id: 3, icon: <IconChecks size={24} />, label: "Resolved" },
  { id: 4, icon: <IconCircleCheck size={24} />, label: "Closed" },
];

// import CustomerCard from "./CustomerCard";
// import View_DetailsProduct from "./ViewDetail/View_DetailsCustomer";
const BugsList = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [salesHeadFilter, setSalesHeadFilter] = useState("");
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const [showAddComments, setShowAddComments] = useState(false);
  const [showViewDetails, setShowViewDetails] = useState(false);
  const [priorityFilter, setPriorityFilter] = useState("");
  const getCurrentStepIndex = (status) => {
    switch (status) {
      case "OPEN":
        return 0;
      case "INPROGRESS":
        return 1;
      case "RESOLVED":
        return 2;
      case "CLOSED":
        return 3;
      default:
        return 0;
    }
  };

  const navigate = useNavigate();
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });
  const [isCardOpen, setIsCardOpen] = useState({
    show: false,
    auto_id: null,
    primary_email: null,
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    user: null,
    message: "",
  });

  const { data: bugs, postData: fetchBugs } = usePostRequest(
    API_ENDPOINTS.GET_BUGS
  );

  const { isLoading, postData: updateCustomerStatus } = usePostRequest(
    API_ENDPOINTS.CUSTOMER_STATUS_UPDATE
  );

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setPage(1);
    setLimit(selectedLimit);
  };

  const handleViewClick = (bug) => {
    setShowViewDetails(true);
    handleAppendId(bug);
  };

  const handleCloseViewDetails = () => {
    setShowViewDetails(false);
  };

  useIdleLogout();

  useEffect(() => {
    fetchBugs({
      page,
      limit,
      search: searchTerm || null, // Pass search term to API
      priority: priorityFilter || null,
      status: salesHeadFilter || null,
    });
  }, [page, limit, isSearchClicked]);

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    fetchBugs({ page, limit });
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during deactivation.");
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSalesHeadFilter("");
    setPriorityFilter("");
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleCloseCard = () => {
    setIsCardOpen({ show: false, auto_id: null, primary_email: null });
    fetchBugs({ page, limit });
  };

  const handlesalesHeadFilter = (e) => {
    setSalesHeadFilter(e.target.value);
  };

  const handlepriorityFilter = (e) => {
    setPriorityFilter(e.target.value);
  };

  const handleEditClick = (bug) => {
    setShowCreateOrder(true);
    handleAppendId(bug);
  };

  const handleCommentClick = (bug) => {
    setShowAddComments(true);
    handleAppendId(bug);
  };

  const handleAppendId = (customer) => {
    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${customer.auto_id}`;
    window.history.pushState(null, "", newUrl);
  };

  return (
    <>
      <UpdateStatus
        show={showCreateOrder}
        onClose={() => setShowCreateOrder(false)}
      />
      <AddComments
        show={showAddComments}
        onClose={() => setShowAddComments(false)}
      />
      <ViewBugDetails
        showPopup={showViewDetails}
        onClose={handleCloseViewDetails}
      />

      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">Bug List</h2>
          </div>
        </div>
      </div>

      <Card className="mb-3">
        <CardBody>
          <Form
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          >
            <Row className="align-items-end">
              <Col md={3}>
                <Form.Label>Search Bug</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                  />
                </InputGroup>
              </Col>
              <Col md={3} className="">
                <Form.Label className="form-label">Filter by Stage</Form.Label>
                <Form.Select
                  className="form-control"
                  value={salesHeadFilter}
                  onChange={handlesalesHeadFilter}
                >
                  <option value={""}>All</option>
                  <option value="OPEN">Open</option>
                  <option value="INPROGRESS">InProgress</option>
                  <option value="RESOLVED">Resolved</option>
                  <option value="CLOSED">Closed</option>
                </Form.Select>
              </Col>
              <Col md={3} className="">
                <Form.Label className="form-label">
                  Filter by Priority
                </Form.Label>
                <Form.Select
                  className="form-control"
                  value={priorityFilter}
                  onChange={handlepriorityFilter}
                >
                  <option value={""}>All</option>
                  <option value="LOW">Low</option>
                  <option value="MEDIUM">Medium</option>
                  <option value="HIGH">High</option>
                  <option value="CRITICAL">Critical</option>
                </Form.Select>
              </Col>
              <Col md={3}>
                <div className="d-flex gap-2">
                  <Button
                    className="w-100"
                    variant="warning"
                    onClick={handleSearch}
                  >
                    Apply Filters
                  </Button>
                  <Button
                    className="w-100"
                    variant="outline-secondary"
                    onClick={handleClearSearch}
                  >
                    Clear Filters
                  </Button>
                </div>
              </Col>
              <Form.Text>Search by Bug's title, stage, or priority.</Form.Text>
            </Row>
          </Form>
        </CardBody>
      </Card>

      <Row>
        {bugs?.data?.map((bug, index) => (
          <Col md={4} key={index}>
            <Card
              className="status_item_card w-100 mb-4"
              // style={{ cursor: "pointer" }}
            >
              <Card.Body>
                <Card.Title>{bug.title}</Card.Title>
                <Card.Text className="d-flex gap-2 align-items-center mb-0">
                  <span
                      className={`badge ${
                        bug?.priority === "MEDIUM"
                          ? "bg-yellow text-yellow-fg"
                          : ""
                      } 
                      ${bug?.priority === "LOW" ? "bg-cyan text-cyan-fg" : ""} 
                      ${bug?.priority === "HIGH" ? "bg-orange text-orange-fg" : ""} 
                      ${bug?.priority === "CRITICAL" ? "bg-red text-red-fg" : ""}`}
                  >
                    {bug?.priority}
                  </span>

                  <div className="value_card">
                    {" "}
                    <span>Created:</span>{" "}
                    {moment(bug.createdAt).format("MM/DD/YYYY")}
                  </div>
                  <div className="value_card">
                    <span>By:</span> {bug?.User?.first_name || ""}{" "}
                    {bug?.User?.last_name || ""}
                  </div>
                </Card.Text>
                <div className="bug_card">
                  <p className="mb-0">{bug?.description}</p>
                </div>
                <div className="bugs_steps">
                  {steps.map((step, stepIndex) => {
                    const currentStep = getCurrentStepIndex(bug.status);
                    return (
                      <div
                        key={stepIndex}
                        className={`step-item ${
                          stepIndex === currentStep
                            ? "active"
                            : stepIndex < currentStep
                            ? "completed"
                            : ""
                        }`}
                      >
                        <div className="step-icon">{step.icon}</div>
                        <div className="step-label">{step.label}</div>
                        {stepIndex !== steps.length - 1 && (
                          <div className="step-line"></div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <Card.Footer className="pe-0 ps-0 border-0 pb-0 bg-transparent pt-3">
                  <span
                    className="big_badge bg-cyan-lt"
                    onClick={() => {
                      if (bug?.status !== "CLOSED") {
                        handleEditClick(bug);
                      }
                    }}
                    style={{
                      cursor:
                        bug?.status === "CLOSED" ? "not-allowed" : "pointer",
                    }}
                  >
                    {" "}
                    <IconEdit width={18} height={18} /> Edit
                  </span>
                  <span
                    className="big_badge badge_btn"
                    onClick={() => handleCommentClick(bug)}
                  >
                    {" "}
                    <IconMessage2 width={18} height={18} /> Comment
                  </span>
                  <span
                    className="big_badge badge_btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewClick(bug); // Trigger the view action
                    }}
                  >
                    {" "}
                    <IconEye width={18} height={18} /> View
                  </span>
                </Card.Footer>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {bugs?.data?.length > 0 && (
        <DynamicPagination
          totalPages={bugs?.pagination?.totalPages}
          currentPage={page}
          onPageChange={handlePageChange}
          limitPerPage={limit}
          onLimitChange={handleLimitChange}
        />
      )}
    </>
  );
};

export default BugsList;
